import CourseChapterEdit from "./CourseChapterEdit";
import CourseChapterCreate from "./CourseChapterCreate";

const chapters = {
  edit: CourseChapterEdit,
  create: CourseChapterCreate,
};

export default chapters;
